<mat-sidenav-container>
  <mat-sidenav #drawer class="sidenav mat-elevation-z8" fixedInViewport
  [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
  [mode]="(isHandset$ | async) ? 'over' : 'side'" [fxHide]="!(isHandset$ | async)">
  <img class="mat-elevation-z8" [src]="logoVisorWeb" width="240" height="auto"
    style="margin-bottom: 18px;" />
  <span class="toolbar-spacer" fxHide.sm
    fxShow.xs><app-date-data-actual></app-date-data-actual></span>
  <button mat-button [matMenuTriggerFor]="userSideMenu" class="menu-button">
    <mat-icon style="font-size: 40px; width: auto; height: auto;">account_circle</mat-icon>
      <span>{{ username }}</span>
      <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #userSideMenu="matMenu">
    <button mat-menu-item (click)="navigateMenu('infoUser');drawer.toggle();">
      <mat-icon>person</mat-icon>
      <span>Mi Perfil</span>
    </button>
    <button mat-menu-item (click)="navigateMenu('cambioClaveUser');drawer.toggle();">
      <mat-icon>lock</mat-icon>
      <span>Cambiar Contraseña</span>
    </button>
    <button mat-menu-item (click)="logout();drawer.toggle();">
      <mat-icon>logout</mat-icon>
      <span>Salir</span>
    </button>
  </mat-menu>
<mat-divider></mat-divider>
  <button mat-button *ngIf="viewScreen == '1'" (click)="navigateMenu('home');drawer.toggle();" class="menu-button name">
    <mat-icon class="mat-icon-menu"><img src="./assets/img/imgbin_house.ico" width="29px" height="29px" class="icono-menu">
    </mat-icon>
    <span>Inicio</span>
</button>
<button mat-button *ngIf="viewScreen == '1'" [matMenuTriggerFor]="materialesSideMenu" class="menu-button name">
  <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-materiales.png" width="29px" height="29px"
      class="icono-menu"></mat-icon>
    <span>Materiales</span>
    <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #materialesSideMenu="matMenu">
  <button mat-menu-item (click)="navigateMenu('materiales');drawer.toggle();">
    <mat-icon>square</mat-icon>
    <span>Materiales Simples</span>
  </button>
  <button mat-menu-item (click)="navigateMenu('matCompuestos');drawer.toggle();">
    <mat-icon>widgets</mat-icon>
    <span>Materiales Compuestos</span>
  </button>
</mat-menu>
<button mat-button *ngIf="viewScreen == '1'" [matMenuTriggerFor]="equiposSideMenu" class="menu-button name">
  <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-equipos.png" width="29px" height="29px" class="icono-menu">
  </mat-icon>
    <span>Equipos</span>
    <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #equiposSideMenu="matMenu">
  <button mat-menu-item (click)="navigateMenu('equipos');drawer.toggle();">
    <mat-icon>square</mat-icon>
    <span>Equipos Simples</span>
  </button>
  <button mat-menu-item (click)="navigateMenu('equiposCompuestos');drawer.toggle();">
    <mat-icon>widgets</mat-icon>
    <span>Equipos Compuestos</span>
  </button>
</mat-menu>
<button mat-button *ngIf="viewScreen == '1'" [matMenuTriggerFor]="manoObraSideMenu" class="menu-button name">
  <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-mano-obra.png" width="29px" height="29px"
      class="icono-menu"></mat-icon>
    <span>Mano de Obra</span>
    <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #manoObraSideMenu="matMenu">
  <button mat-menu-item (click)="navigateMenu('manoDeObra');drawer.toggle();">
    <mat-icon>square</mat-icon>
    <span>Obras Simples</span>
  </button>
  <button mat-menu-item (click)="navigateMenu('manoDeObraCompuesta');drawer.toggle();">
    <mat-icon>widgets</mat-icon>
    <span>Obras Compuestas</span>
  </button>
</mat-menu>
<button mat-button *ngIf="viewScreen == '1'" [matMenuTriggerFor]="partidasSideMenu" class="menu-button name">
  <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-partidas.png" width="29px" height="29px" class="icono-menu">
  </mat-icon>
    <span>Partidas</span>
    <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #partidasSideMenu="matMenu">
  <button mat-menu-item (click)="navigateMenu('partidas/construccion');drawer.toggle();">
    <mat-icon>description</mat-icon>
    <span>Partidas Construcción</span>
  </button>
  <button mat-menu-item (click)="navigateMenu('partidas/petroleras');drawer.toggle();">
    <mat-icon>class</mat-icon>
    <span>Partidas Petroleras</span>
  </button>
</mat-menu>
<button mat-button *ngIf="viewScreen == '1'" (click)="navigateMenuPresupuesto();drawer.toggle();"
  class="menu-button name">
  <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-presupuesto.png" width="29px" height="29px"
      class="icono-menu">
  </mat-icon>
  <span>Presupuestos</span>
</button>
<button mat-button *ngIf="viewScreen == '2'" [matMenuTriggerFor]="presupuestoSideMenu" class="menu-button name">
  <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-presupuesto.png" width="29px" height="29px"
      class="icono-menu">
  </mat-icon>
  <span>Presupuestos</span>
  <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #presupuestoSideMenu="matMenu">
  <button mat-menu-item (click)="navigateMenu('nuevoPresupuesto');drawer.toggle();">
    <mat-icon>description</mat-icon>
    <span>Nuevo Presupuesto</span>
  </button>
  <button mat-menu-item (click)="navigateMenu('presupuestos');drawer.toggle();">
    <mat-icon>class</mat-icon>
    <span>Lista Presupuestos</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="navigateMenuBaseDatos()">
    <mat-icon>logout</mat-icon>
    <span>Salir Presupuesto</span>
  </button>
  </mat-menu>
  <mat-divider *ngIf="viewScreen == '1'"></mat-divider>
<button mat-button *ngIf="userprofile == '1' && viewScreen == '1'" [matMenuTriggerFor]="manageSideMenu"
  class="menu-button name">
  <mat-icon title="Administración Usuarios">manage_accounts</mat-icon>
  <span>Administración Usuarios</span>
  <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #manageSideMenu="matMenu">
  <button mat-menu-item (click)="navigateMenu('nuevoUsuario');drawer.toggle();">
    <mat-icon>person_add</mat-icon>
    <span>Nuevo Usuario</span>
  </button>
  <button mat-menu-item (click)="navigateMenu('listaUsuarios');drawer.toggle();">
    <mat-icon>contacts</mat-icon>
    <span>Lista Usuarios</span>
  </button>
</mat-menu>
<button mat-button [matMenuTriggerFor]="settingSideMenu" class="menu-button name">
  <mat-icon title="Configuración">settings_suggest</mat-icon>
  <span>Configuración</span>
  <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #settingSideMenu="matMenu">
  <button mat-menu-item *ngIf="userprofile == '1' && viewScreen == '1'"
    (click)="navigateMenu('actualizarBd');drawer.toggle();" fxHide.xs>
    <mat-icon>settings</mat-icon>
    <span>Carga y Actualización BD</span>
  </button>
  <button mat-menu-item *ngIf="userprofile == '1' && viewScreen == '2'"
    (click)="navigateMenu('actualizarBdCapitulos');drawer.toggle();" fxHide.xs>
    <mat-icon>settings</mat-icon>
    <span>Carga y Actualización Capítulos</span>
    </button>
    <button mat-menu-item *ngIf="viewScreen == '1'" (click)="navigateMenu('cambioFechaBd');drawer.toggle();">
      <mat-icon>settings</mat-icon>
      <span>Cambiar Fecha BD</span>
    </button>
    <button mat-menu-item *ngIf="viewScreen == '2'" (click)="cambiarFechasBdPresupuesto();drawer.toggle();">
      <mat-icon>settings</mat-icon>
      <span>Cambiar Fecha BD</span>
    </button>
</mat-menu>
<mat-divider></mat-divider>
<button mat-button (click)="drawer.toggle()" class="menu-button name">
    <mat-icon>close</mat-icon>
    <span>Cerrar menú</span>
</button>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="mat-toolbar-azul">
      <mat-toolbar-row style="width: 5% !important;" fxHide.md fxHide.lg>
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <img [src]="logoVisorWeb" alt="Site Logo" width="250" height="auto" style="padding-top: 0px;" />
        <span class="toolbar-spacer" fxHide.xs><app-date-data-actual></app-date-data-actual></span>
        <button mat-button *ngIf="userprofile == '1' && viewScreen == '1'" [matMenuTriggerFor]="manageMenu" fxHide.xs fxHide.sm>
          <mat-icon title="Administración Usuarios">manage_accounts</mat-icon>
          <span>Administración Usuarios</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #manageMenu="matMenu" yPosition="above" class="customenucolor">
          <button mat-menu-item (click)="navigateMenu('nuevoUsuario')">
            <mat-icon>person_add</mat-icon>
            <span>Nuevo Usuario</span>
          </button>
          <button mat-menu-item (click)="navigateMenu('listaUsuarios')">
            <mat-icon>contacts</mat-icon>
            <span>Lista Usuarios</span>
          </button>
        </mat-menu>

        <button mat-button [matMenuTriggerFor]="settingsMenu" fxHide.xs fxHide.sm>
          <mat-icon title="Configuración">settings_suggest</mat-icon>
          <span>Configuración</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #settingsMenu="matMenu" yPosition="below" class="customenucolor">
          <button mat-menu-item *ngIf="userprofile == '1' && viewScreen == '1'" (click)="navigateMenu('actualizarBd')">
            <mat-icon>settings</mat-icon>
            <span>Carga y Actualización BD</span>
          </button>
          <button mat-menu-item *ngIf="userprofile == '1' && viewScreen == '2'" (click)="navigateMenu('actualizarBdCapitulos')"
            fxHide.xs>
            <mat-icon>settings</mat-icon>
            <span>Carga y Actualización Capítulos</span>
            </button>
          <button mat-menu-item *ngIf="viewScreen == '1'" (click)="navigateMenu('cambioFechaBd')">
            <mat-icon>settings</mat-icon>
            <span>Cambiar Fecha BD</span>
          </button>
          <button mat-menu-item *ngIf="viewScreen == '2'" (click)="cambiarFechasBdPresupuesto()">
            <mat-icon>settings</mat-icon>
            <span>Cambiar Fecha BD</span>
          </button>
        </mat-menu>

        <button mat-button *ngIf="viewScreen == '2'" [matMenuTriggerFor]="presupuestoMenu" fxHide.xs fxHide.sm>
          <mat-icon>article</mat-icon>
          <span>Menu Presupuestos</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu class="customenucolor" #presupuestoMenu="matMenu" yPosition="below">
          <button mat-menu-item (click)="navigateMenu('presupuestos')">
            <mat-icon>grading</mat-icon>
            <span>Lista de Presupuestos</span>
          </button>
          <button mat-menu-item (click)="navigateMenu('nuevoPresupuesto')">
            <mat-icon>note_add</mat-icon>
            <span>Nuevo Presupuesto</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="navigateMenuBaseDatos()">
            <mat-icon>logout</mat-icon>
            <span>Salir Presupuesto</span>
          </button>
        </mat-menu>

        <button mat-button [matMenuTriggerFor]="userMenu" fxHide.xs fxHide.sm>
          <mat-icon >account_circle</mat-icon>
          <span>{{ username }}</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu class="customenucolor" #userMenu="matMenu" yPosition="below">
          <button mat-menu-item (click)="navigateMenu('infoUser')">
            <mat-icon>person</mat-icon>
            <span>Mi Perfil</span>
          </button>
          <button mat-menu-item (click)="navigateMenu('cambioClaveUser')">
            <mat-icon>lock</mat-icon>
            <span>Cambiar Contraseña</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="confirmLogout()">
            <mat-icon>logout</mat-icon>
            <span>Salir</span>
          </button>
        </mat-menu>
      </mat-toolbar-row>
    </mat-toolbar>
    <mat-toolbar [ngClass]="viewScreen == '1' ? 'menu justify-content-center' : 'menu-presupuesto justify-content-center'">
      <div *ngIf="viewScreen == '1'" class="mainbar-collapse" style="padding-top: 8px;" fxHide.xs fxHide.sm>
        <button mat-raised-button mat-elevation-z8 (click)="navigateMenu('home')">
          <div mat-elevation-z8 class="outer-div">
            <mat-icon class="mat-icon-menu"><img src="./assets/img/imgbin_house.ico" width="59px" height="59px" class="icono-menu">
            </mat-icon>
            <span>Inicio</span>
          </div>
        </button>
        <button mat-raised-button [matMenuTriggerFor]="materialesMenu" aria-label="Example icon-button with a menu">
          <div class="outer-div">
            <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-materiales.png" width="59px" height="59px"
                class="icono-menu"></mat-icon>
            <div class="divmenu">
              <span>Materiales</span>
              <mat-icon>arrow_drop_down</mat-icon>
            </div>
          </div>
        </button>
        <mat-menu #materialesMenu="matMenu" class="customenucolor">
          <button mat-menu-item (click)="navigateMenu('materiales')">
            <mat-icon>square</mat-icon>
            <span>Materiales Simples</span>
          </button>
          <button mat-menu-item (click)="navigateMenu('matCompuestos')">
            <mat-icon>widgets</mat-icon>
            <span>Materiales Compuestos</span>
          </button>
        </mat-menu>
        <button mat-raised-button [matMenuTriggerFor]="equiposMenu" aria-label="Example icon-button with a menu">
          <div class="outer-div">
            <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-equipos.png" width="59px" height="59px" class="icono-menu">
            </mat-icon>
            <div class="divmenu">
              <span>Equipos</span>
              <mat-icon>arrow_drop_down</mat-icon>
            </div>
          </div>
        </button>
        <mat-menu #equiposMenu="matMenu" class="customenucolor">
          <button mat-menu-item (click)="navigateMenu('equipos')">
            <mat-icon>square</mat-icon>
            <span>Equipos Simples</span>
          </button>
          <button mat-menu-item (click)="navigateMenu('equiposCompuestos')">
            <mat-icon>widgets</mat-icon>
            <span>Equipos Compuestos</span>
          </button>
        </mat-menu>
        <button mat-raised-button [matMenuTriggerFor]="manoObraMenu" aria-label="Example icon-button with a menu">
          <div class="outer-div">
            <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-mano-obra.png" width="59px" height="59px"
                class="icono-menu"></mat-icon>
            <div class="divmenu">
              <span>Mano de Obra</span>
              <mat-icon>arrow_drop_down</mat-icon>
            </div>
          </div>
        </button>
        <mat-menu #manoObraMenu="matMenu" class="customenucolor">
          <button mat-menu-item (click)="navigateMenu('manoDeObra')">
            <mat-icon>square</mat-icon>
            <span>Mano de Obra Simple</span>
          </button>
          <button mat-menu-item (click)="navigateMenu('manoDeObraCompuesta')">
            <mat-icon>widgets</mat-icon>
            <span>Manos de Obra Compuestas</span>
          </button>
        </mat-menu>
        <button mat-raised-button [matMenuTriggerFor]="partidasMenu" aria-label="Example icon-button with a menu">
          <div class="outer-div">
            <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-partidas.png" width="59px" height="59px" class="icono-menu">
            </mat-icon>
            <div class="divmenu">
              <span>Partidas</span>
              <mat-icon>arrow_drop_down</mat-icon>
              </div>
          </div>
        </button>
        <mat-menu #partidasMenu="matMenu" class="customenucolor">
          <button mat-menu-item (click)="navigateMenu('partidas/construccion')">
            <mat-icon>description</mat-icon>
            <span>Partidas Construcción</span>
          </button>
          <button mat-menu-item (click)="navigateMenu('partidas/petroleras')">
            <mat-icon>class</mat-icon>
            <span>Partidas Petroleras</span>
          </button>
        </mat-menu>
        <button mat-raised-button mat-elevation-z8 (click)="navigateMenuPresupuesto()">
          <div mat-elevation-z8 class="outer-div">
            <mat-icon class="mat-icon-menu"><img src="./assets/img/icon-presupuesto.png" width="59px" height="59px"
                class="icono-menu">
            </mat-icon>
            <span>Presupuestos</span>
          </div>
        </button>
      </div>
    </mat-toolbar>
    <div fxLayout="row" fxLayoutAlign="center stretch" >
      <mat-card [ngClass]="viewScreen == '1' ? 'card-home' : 'card-home-presupuesto'">
        <mat-card-content [ngClass]="viewScreen == '1' ? 'content-home' : 'content-home-presupuesto'">
          <router-outlet></router-outlet>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<mat-drawer-container class="example-container" autosize>
  <mat-drawer #drawerPres class="example-sidenav" mode="over">
    <p>Auto-resizing sidenav</p>
    <div class="example-sidenav-content">
      <button type="button" mat-button (click)="drawer.toggle()">
        Toggle sidenav
      </button>
    </div>
  </mat-drawer>
</mat-drawer-container>
